(() => {
    const toggleFilterLists = () => {
        const toggles = document.querySelectorAll('.js-filter-toggle');

        if (!toggles.length) return;

        toggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const nextEl = toggle.nextElementSibling;
                if (!nextEl || !nextEl.classList.contains('js-filter-list')) return;
                const icon = toggle.querySelector('.js-filter-icon');

                nextEl.classList.toggle('is-open');
                icon?.classList.toggle('is-rotated');
            });
        });
    };

    toggleFilterLists();
})();